<template>
  <div>
    <el-table
      :data="servers"
      style="width: 100%"
      border
      :row-class-name="tableRowClassName"
      :header-cell-style="{ background: '#ecf4ff',color: '#333',fontWeight: '900',fontSize: '0.28rem' }"
    >
      <el-table-column prop="role" label="角色" width="150"> </el-table-column>
      <el-table-column label="姓名">
        <template slot-scope="scope">
          <company-single-server 
            :singleServer="scope.row" 
            :key="scope.row.id" 
            :cid="cid" 
            :userList="userList"
            @tagClosed="handleCloseTag"
            @selectChanged="setShareUser"
            @selectClick="showSelect"
          >
        </company-single-server>
      </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import CompanySingleServer from 'common/CompanySingleServer';
export default {
  name: "CompanyMultipleServer",
  components: { CompanySingleServer },
  props: {
    cid: Number
  },
  watch: {
    cid: {
      handler(newVal) {
        if (newVal) {
          this.servers = [];
          this.company_id = newVal;
          this.loadAdminUser(newVal);
        }
      },
      immediate: true,
    }
  },
  computed: {
  },
  created() {

  },
  data() {
    return {
      servers: [],
      userList: [],
      company_id: null,
    };
  },
  methods: {
    loadAdminUser(val) {
      this.$axios
        .get("api/company_com/cross/get_adminuser_share", {
          params: {
            company_id: val,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.userList = data.data.adminUser;
            this.servers = data.data.share;
          }
        })
        .catch();
    },
    showSelect(event, role, selectRef) {
      this.servers.forEach(roleObj => {
        if (roleObj.role === role) {
          roleObj.isShow = true;
          this.$nextTick(() => {
            const selectComponent = this.$refs[selectRef];
            if (selectComponent && selectComponent.$el) {
              selectComponent.$refs.input.focus();
            }
          });
        }
      });
    },
    handleCloseTag(tags, selectList, cid, role, itemType) {
      const tagId = tags.id;
      const updatedSelectList = selectList.filter(item => item !== tagId);
      this.setShareUser(updatedSelectList, cid, role, itemType);
    },
    setShareUser(val, cid, role, itemType) {
      this.$axios
        .post("api/company_com/cross/set_share", {
          company_id: cid,
          users: val,
          role: role,
          itemType: itemType
        })
        .then(({ data }) => {
          if (data.code === 1) {
            if (data.cid) {
              this.loadAdminUser(data.cid)
            }
            this.$message.success(data.msg);
          }
        })
        .catch();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
  },
  mounted() {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/CompanyMultipleServer.vue